import type { LoadOptions } from 'devextreme/data';

/** SMS EntityList-like DataGrid visual defaults. */
export const trackerGridProps = {
  showBorders: false,
  showRowLines: false,
  showColumnLines: false,
  rowAlternationEnabled: true,
  hoverStateEnabled: true,
  columnAutoWidth: true,
  allowColumnResizing: true,
  wordWrapEnabled: false,
} as const;

export function pageFromLoadOptions(loadOptions: LoadOptions, defaultSize: number) {
  const take =
    typeof loadOptions.take === 'number' && loadOptions.take > 0
      ? loadOptions.take
      : defaultSize;
  const skip = typeof loadOptions.skip === 'number' ? loadOptions.skip : 0;
  const page = take > 0 ? Math.floor(skip / take) + 1 : 1;
  return { page, page_size: take };
}

type GridLike = {
  pageIndex: (n?: number) => number;
  refresh: () => void | Promise<unknown>;
  getDataSource?: () => { reload: () => Promise<unknown> } | null | undefined;
} | null | undefined;

/**
 * Force remote CustomStore reload from page 0.
 * Prefer DataSource.reload() — grid.refresh() is a no-op in some DX states when already on page 0.
 */
export function resetGridPage(grid: GridLike) {
  if (!grid) return;
  const ds = grid.getDataSource?.();
  if (grid.pageIndex() !== 0) {
    grid.pageIndex(0);
    return;
  }
  if (ds?.reload) {
    void ds.reload();
    return;
  }
  void grid.refresh();
}
